
import React, { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ReservationSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: '2',
    table: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Kirim ke WhatsApp juga
      const reservationMessage = `🏮 RESERVASI TAKEYA RESTAURANT 🏮\n\n👤 Nama: ${formData.name}\n📧 Email: ${formData.email}\n📱 Phone: ${formData.phone}\n📅 Tanggal: ${formData.date}\n⏰ Waktu: ${formData.time}\n👥 Jumlah Tamu: ${formData.guests} orang\n🪑 Meja: ${formData.table || 'Tidak ada preferensi'}\n💬 Pesan: ${formData.message || 'Tidak ada pesan khusus'}\n\nMohon konfirmasi ketersediaan meja.\nTerima kasih! 🙏`;
      const phoneNumber = '628127543743';
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(reservationMessage)}`;
      
      const response = await fetch('https://readdy.ai/api/form/d30obtiuu7nqqcqu7u5g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(Object.entries(formData)).toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          date: '',
          time: '',
          guests: '2',
          table: '',
          message: ''
        });
        
        // Buka WhatsApp setelah form berhasil dikirim
        setTimeout(() => {
          window.open(whatsappUrl, '_blank');
        }, 1500);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 5000);
    }
  };

  const timeSlots = [
    '10:00', '10:30', '11:00', '11:30', '12:00', '12:30',
    '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
    '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
    '19:00', '19:30', '20:00', '20:30', '21:00', '21:30'
  ];

  const tableOptions = [
    { id: 'A1', name: 'Meja A1 - Window View (2-4 orang)', capacity: '2-4' },
    { id: 'A2', name: 'Meja A2 - Corner Table (2-4 orang)', capacity: '2-4' },
    { id: 'B1', name: 'Meja B1 - Center Hall (4-6 orang)', capacity: '4-6' },
    { id: 'B2', name: 'Meja B2 - Private Booth (4-6 orang)', capacity: '4-6' },
    { id: 'C1', name: 'Meja C1 - Family Table (6-8 orang)', capacity: '6-8' },
    { id: 'VIP1', name: 'VIP Room 1 - Tatami Style (8-12 orang)', capacity: '8-12' },
    { id: 'VIP2', name: 'VIP Room 2 - Modern Style (8-12 orang)', capacity: '8-12' }
  ];

  const reservationSteps = [
    {
      step: '1',
      title: 'Pilih Tanggal & Waktu',
      description: 'Tentukan kapan Anda ingin menikmati hidangan kami',
      icon: 'ri-calendar-line'
    },
    {
      step: '2',
      title: 'Isi Data Diri',
      description: 'Lengkapi informasi kontak untuk konfirmasi',
      icon: 'ri-user-line'
    },
    {
      step: '3',
      title: 'Konfirmasi Reservasi',
      description: 'Dapatkan konfirmasi langsung via WhatsApp',
      icon: 'ri-check-line'
    }
  ];

  return (
    <section id="reservation" className="py-20 bg-gradient-to-b from-gray-900 to-black dark:from-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-white mb-6" style={{ fontFamily: '"Noto Sans JP", serif' }}>
            Reservasi <span className="text-red-500">Online</span>
            <span className="block text-3xl text-yellow-400 mt-2">オンライン予約</span>
          </h2>
          <div className="flex items-center justify-center space-x-4 mb-8">
            <div className="h-px w-20 bg-gradient-to-r from-transparent to-red-500"></div>
            <div className="text-yellow-400 text-lg font-bold" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              BOOK YOUR TABLE
            </div>
            <div className="h-px w-20 bg-gradient-to-l from-transparent to-red-500"></div>
          </div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Reservasi meja Anda untuk pengalaman kuliner Jepang yang tak terlupakan. Konfirmasi instan via WhatsApp!
          </p>
        </div>

        {/* Reservation Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {reservationSteps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-700 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <i className={`${step.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-500 text-black rounded-full flex items-center justify-center font-bold text-sm">
                  {step.step}
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
              <p className="text-gray-300 text-sm">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Reservation Form */}
          <div className="bg-gradient-to-br from-red-900/20 to-yellow-900/20 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
            <h3 className="text-3xl font-bold text-white mb-8 text-center">Form Reservasi</h3>
            
            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-500/20 border border-green-500/50 rounded-2xl">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-400 text-xl w-5 h-5 flex items-center justify-center"></i>
                  <p className="text-green-400 font-semibold">Reservasi berhasil dikirim! Kami akan menghubungi Anda segera melalui WhatsApp untuk konfirmasi.</p>
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-2xl">
                <div className="flex items-center space-x-3">
                  <i className="ri-error-warning-line text-red-400 text-xl w-5 h-5 flex items-center justify-center"></i>
                  <p className="text-red-400 font-semibold">Terjadi kesalahan. Silakan coba lagi atau hubungi kami langsung via WhatsApp.</p>
                </div>
              </div>
            )}

            <form id="reservation-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-white font-semibold mb-2">Nama Lengkap *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none transition-colors text-sm"
                    placeholder="Masukkan nama lengkap"
                  />
                </div>
                <div>
                  <label className="block text-white font-semibold mb-2">Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none transition-colors text-sm"
                    placeholder="email@example.com"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-white font-semibold mb-2">No. Telepon *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none transition-colors text-sm"
                    placeholder="+62 xxx xxxx xxxx"
                  />
                </div>
                <div>
                  <label className="block text-white font-semibold mb-2">Jumlah Tamu *</label>
                  <select
                    name="guests"
                    value={formData.guests}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white focus:border-red-500 focus:outline-none transition-colors text-sm pr-8"
                  >
                    {Array.from({length: 12}, (_, i) => i + 1).map(num => (
                      <option key={num} value={num.toString()}>{num} orang</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-white font-semibold mb-2">Tanggal Reservasi *</label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                    min={new Date().toISOString().split('T')[0]}
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white focus:border-red-500 focus:outline-none transition-colors text-sm"
                  />
                </div>
                <div>
                  <label className="block text-white font-semibold mb-2">Waktu *</label>
                  <select
                    name="time"
                    value={formData.time}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white focus:border-red-500 focus:outline-none transition-colors text-sm pr-8"
                  >
                    <option value="">Pilih waktu</option>
                    {timeSlots.map(time => (
                      <option key={time} value={time}>{time} WIB</option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-white font-semibold mb-2">Preferensi Meja</label>
                <select
                  name="table"
                  value={formData.table}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white focus:border-red-500 focus:outline-none transition-colors text-sm pr-8"
                >
                  <option value="">Tidak ada preferensi</option>
                  {tableOptions.map(table => (
                    <option key={table.id} value={table.id}>{table.name}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-white font-semibold mb-2">Pesan Khusus</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none transition-colors text-sm resize-none"
                  placeholder="Acara khusus, alergi makanan, atau permintaan lainnya (maksimal 500 karakter)"
                />
                <div className="text-right text-gray-400 text-xs mt-1">
                  {formData.message.length}/500 karakter
                </div>
              </div>

              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="w-full shadow-2xl shadow-red-500/50 whitespace-nowrap cursor-pointer"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line mr-2 w-5 h-5 flex items-center justify-center animate-spin"></i>
                    Mengirim Reservasi...
                  </>
                ) : (
                  <>
                    <i className="ri-whatsapp-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                    Kirim Reservasi via WhatsApp
                  </>
                )}
              </Button>
            </form>
          </div>

          {/* Restaurant Info */}
          <div className="space-y-8">
            {/* Operating Hours */}
            <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Jam Operasional</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Senin - Kamis</span>
                  <span className="text-yellow-400 font-semibold">10:00 - 22:00 WIB</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Jumat - Minggu</span>
                  <span className="text-yellow-400 font-semibold">10:00 - 23:00 WIB</span>
                </div>
                <div className="flex items-center justify-between border-t border-gray-700 pt-4">
                  <span className="text-gray-300">Hari Libur Nasional</span>
                  <span className="text-red-400 font-semibold">Tutup</span>
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Kontak Reservasi</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                    <i className="ri-whatsapp-line text-white w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">WhatsApp</p>
                    <p className="text-gray-300">+62 812 754 3743</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-white w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Telepon</p>
                    <p className="text-gray-300">+62 812 754 3743</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-mail-line text-white w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Email</p>
                    <p className="text-gray-300">info@takeya-restaurant.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Special Notes */}
            <div className="bg-gradient-to-br from-yellow-900/20 to-red-900/20 backdrop-blur-sm rounded-3xl border border-yellow-500/20 p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Catatan Penting</h3>
              <div className="space-y-3 text-gray-300 text-sm">
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-yellow-400 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <p>Reservasi dapat dibuat maksimal 7 hari sebelumnya</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-time-line text-yellow-400 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <p>Toleransi keterlambatan maksimal 15 menit</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-group-line text-yellow-400 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <p>Untuk grup 10+ orang, silakan hubungi langsung</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-calendar-line text-yellow-400 mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                  <p>Pembatalan gratis hingga 2 jam sebelum waktu reservasi</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
